export const DEFAULT_MODEL = "openai:gpt-4.1-mini-2025-04-14"
